export const useColumns = () => [
  {
    minWidth: 200,
    headerName: 'Name',
    field: 'name',
  },
  {
    minWidth: 70,
    headerName: 'Vacation\n(Shifts)',
    field: 'vacation',
  },
  {
    minWidth: 70,
    headerName: 'Holiday\n(Shifts)',
    field: 'holiday',
  },
  {
    minWidth: 95,
    headerName: 'Earned Time\n(Shifts)',
    field: 'earnedTime',
  },
  {
    minWidth: 75,
    headerName: 'Personal\n(Shifts)',
    field: 'personal',
  },
  {
    minWidth: 70,
    headerName: 'Training\n(Shifts)',
    field: 'training',
  },
  {
    minWidth: 95,
    headerName: 'Bereavement\n(Shifts)',
    field: 'bereavement',
  },
  {
    minWidth: 110,
    headerName: 'Union Business\n(Shifts)',
    field: 'unionBusiness',
  },
  {
    minWidth: 150,
    headerName: 'Department Business\n(Shifts)',
    field: 'departmentBusiness',
  },
  {
    minWidth: 85,
    headerName: 'Sick (Self)\n(Shifts)',
    field: 'selfSick',
  },
  {
    minWidth: 95,
    headerName: 'Sick (Family)\n(Shifts)',
    field: 'familySick',
  },
  {
    minWidth: 110,
    headerName: 'Leave with pay\n(Shifts)',
    field: 'leaveWithPay',
  },
  {
    minWidth: 130,
    headerName: 'Leave without pay\n(Shifts)',
    field: 'leaveWithoutPay',
  },
  {
    minWidth: 65,
    headerName: 'Swap\n(Shifts)',
    field: 'swap',
  },
  {
    minWidth: 70,
    headerName: 'Injured\n(Shifts)',
    field: 'injured',
  },
  {
    minWidth: 75,
    headerName: 'Academy\n(Shifts)',
    field: 'academy',
  },
  {
    minWidth: 100,
    headerName: 'Open Position\n(Shifts)',
    field: 'openPosition',
  },
  {
    minWidth: 70,
    headerName: 'FFCRA\n(Shifts)',
    field: 'ffcra',
  },
];
